export default {"src":"/_next/static/media/0x14016e85a25aeb13065688cafb43044c2ef86784.c044dbfa.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};